import { useState, useEffect, useRef } from 'react';

const needsAuthFetch = (url) =>
  typeof url === 'string' && url.startsWith('/Uploads/');

const useAuthUploadSrc = (rawUrl) => {
  const [blobSrc, setBlobSrc] = useState(null);
  const blobRef = useRef(null);

  useEffect(() => {
    if (blobRef.current) {
      URL.revokeObjectURL(blobRef.current);
      blobRef.current = null;
    }
    setBlobSrc(null);
    if (!rawUrl || !needsAuthFetch(rawUrl)) return;

    let cancelled = false;
    const token = localStorage.getItem('token');
    fetch(rawUrl, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      credentials: 'include',
    })
      .then((r) => {
        if (!r.ok) throw new Error(String(r.status));
        return r.blob();
      })
      .then((blob) => {
        if (cancelled) return;
        const url = URL.createObjectURL(blob);
        blobRef.current = url;
        setBlobSrc(url);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [rawUrl]);

  useEffect(
    () => () => {
      if (blobRef.current) URL.revokeObjectURL(blobRef.current);
    },
    [],
  );

  return needsAuthFetch(rawUrl) ? blobSrc : rawUrl;
};

export default useAuthUploadSrc;
